import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { runSubmissionPipeline } from "../../../api/postCall/runSubmissionPipeline";
import { FilterValues } from "../../../data-model/filterValues";
import {
  buildRunSubmissionPipelinePayload,
  hasDeliveryPipelineFilters,
} from "../utils/buildRunSubmissionPipelinePayload";

/**
 * Triggers the new unified delivery pipeline (`/delivery/run-submission-pipeline`)
 * for the given filter scope, and surfaces a toast.
 *
 * Supersedes the legacy "Track Status" / "Upload Outcome" actions, which run the
 * old per-step endpoints and are disabled on this tab (see `buttonDropdownConfig.ts`).
 *
 * Callers are responsible for their own scope-selection gating (see
 * `RunDeliveryPipelineModal`'s `canRun`, which disables its Save button until a
 * qualifying filter is picked); the `hasDeliveryPipelineFilters` check here is a
 * defensive backstop against calling this directly with an unfiltered scope.
 *
 * @param validFilters - Filters describing the scope to run the pipeline against
 * @returns True if the pipeline was accepted; false if blocked by the empty-filters
 *   guard or if the API call failed (both cases surface a toast to the user)
 */
export const handleRunDeliveryPipeline = async (
  validFilters: FilterValues[],
): Promise<boolean> => {
  if (!hasDeliveryPipelineFilters(validFilters)) {
    toast.error(
      "Select a batch, date range, or form filter before running the delivery pipeline.",
    );
    return false;
  }

  const body = buildRunSubmissionPipelinePayload(
    validFilters,
    "pharma-stp-file-delivery-tab",
  );

  try {
    await runSubmissionPipeline(body);
    toast.success("Delivery pipeline run started.");
    return true;
  } catch (error) {
    console.error("Failed to trigger the delivery pipeline:", error);
    toast.error("Failed to start the delivery pipeline. Please try again.");
    return false;
  }
};
